// Create a virtual cart for pods summary
window.podClaimingCart = createVirtualCart(window.country);

// Set credit data for standard pod displayment
const standardPodDisplayment = document.getElementById('credit-displayment-standard');

if (standardPodDisplayment) {
  standardPodDisplayment.setAttribute('credit', window.shopifyCustomerCredit);
}

// Set credit data for any pod displayment
const anyPodDisplayment = document.getElementById('credit-displayment-any');

if (anyPodDisplayment) {
  anyPodDisplayment.setAttribute('credit', window.shopifyCustomerCredit);
}

// Handle quantity change event on product items
window.addEventListener('sh-product-item:change', (event) => {
  window.podClaimingCart.update(event.detail);
});

// Handle show product tray
window.addEventListener('sh-product-item:show-product-details', (event) => {
  // Get event payload
  const productId = event.detail.id;
  const enableMetadata = event.detail.enableMetadata;

  // Get products data
  const productDataJSON = document.getElementById('pods-product-data').innerText;
  const productData = JSON.parse(productDataJSON).reduce((acc, item) => ({ ...acc, [item.id]: item }), {});

  // Get sh-tray element
  const trayElement = document.getElementById('sh-tray');

  // Create product-item element with attributes
  const productItemElement = Object.assign(document.createElement('sh-product-item'), {
    ...productData[productId],
    price: productData[productId].price / 100,
    credit: Number(productData[productId].credit),
    enableMetadata,
    enablePadding: false,
    enableDescription: true,
    enableMoreInformation: false,
  });

  // Replace tray children with created element
  trayElement.replaceChildren(productItemElement);

  // Open tray via update the attribute
  trayElement.setAttribute('open', true);
});
